export interface KeypressDelay {
  delay: number
}
